import React from 'react';
import MyCerteficats from './MyCerteficats';

export default function MyCertificates(props) {
  return <MyCerteficats {...props} />;
}
